import { useTranslation } from "react-i18next";
import { Icon, Navigation } from "../../components";
import { Box, Image, PageContainer, Typography } from "../../shared/ui";
import css from "./ProvablyFairDescription.module.scss";

export const ProvablyFairDescription = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Navigation title={t("provably_fair.title").toUpperCase()} />
      <PageContainer className={css.container}>
        <Typography className={css.title} color="header-small">
          {t("provably_fair.what_is_provably_fair")}
        </Typography>
        <Typography className={css.descr} color="light-grey">
          <Image src="clown.png" className={css.clownIcon} />
          {t("provably_fair.description")}
        </Typography>

        <Typography className={css.title} color="header-small">
          {t("provably_fair.how_it_works")}
        </Typography>
        <Typography className={css.descr} color="light-grey">
          {t("provably_fair.crash_point")}
        </Typography>

        <ul className={`${css.list} ${css.unorderedList}`}>
          <li className={css.listItem}>{t("provably_fair.server")}</li>
          <li className={css.listItem}>{t("provably_fair.player_seeds")}</li>
        </ul>
        <Typography className={css.descr} color="light-grey">
          {t("provably_fair.round_verification")}
        </Typography>

        <div className={css.seedsSchema}>
          <div className={css.seedsRow}>
            <div className={css.seedBlock}>
              <div className={css.seedIcon}>
                <Icon width={42} height={42} name="computer" />
              </div>
              <Typography color="light-grey" variant="caption2">
                {t("provably_fair.server_seed")}
              </Typography>
              <Typography variant="caption1" color="blue">
                AB
              </Typography>
            </div>
            <div className={css.seedBlock}>
              <div className={css.seedIcon}>
                <Icon width={42} height={42} name="smile" />
              </div>
              <Typography color="light-grey" variant="caption2">
                {t("provably_fair.player_seed", { number: 1 })}
              </Typography>
              <Typography variant="caption1" color="blue">
                CD
              </Typography>
            </div>
          </div>

          <div className={css.seedsRow}>
            <div className={css.seedBlock}>
              <div className={css.seedIcon}>
                <Icon width={42} height={42} name="smile" />
              </div>
              <div className={css.seedLabel}>
                <Typography color="light-grey" variant="caption2">
                  {t("provably_fair.player_seed", { number: 2 })}
                </Typography>
              </div>
              <Typography variant="caption1" color="blue">
                EF
              </Typography>
            </div>
            <div className={css.seedBlock}>
              <div className={css.seedIcon}>
                <Icon width={42} height={42} name="smile" />
              </div>
              <div className={css.seedLabel}>
                <Typography color="light-grey" variant="caption2">
                  {t("provably_fair.player_seed", { number: 3 })}
                </Typography>
              </div>
              <Typography variant="caption1" color="blue">
                GH
              </Typography>
            </div>
          </div>

          <div className={css.connectionLines}>
            <Image
              src="left-line.png"
              variant="base"
              className={css.leftLine}
            />
            <Image
              src="right-line.png"
              variant="base"
              className={css.rightLine}
            />
          </div>

          <div className={css.combinedBlock}>
            <Typography color="light-grey" variant="caption2">
              {t("provably_fair.combined_seed")}
            </Typography>
            <Typography variant="caption1" color="blue">
              ABCDEFGH
            </Typography>
          </div>

          <div className={css.hashBlock}>
            <Typography color="light-grey" variant="caption2">
              {t("provably_fair.combined_hash")}
            </Typography>
            <Typography
              variant="caption1"
              color="blue"
              className={css.hashValue}
            >
              8b66b893918da31d49763a6c420b4cad75a2663682bb317da79106facfb08e5f812adbc33f71b3088fc778355590dfcad5a7dcf9953ee761522318ef98495730
            </Typography>
          </div>

          <div className={css.resultBlock}>
            <Typography variant="caption2" color="light-grey">
              {t("provably_fair.round_result")}
            </Typography>
            <Typography className={css.value} variant="caption1" color="blue">
              2.15
            </Typography>
          </div>
        </div>
        <Typography className={css.title} color="header-small">
          {t("provably_fair.how_to_check")}
        </Typography>
        <ol className={`${css.list} ${css.orderedList}`}>
          <li className={css.listItem}>{t("provably_fair.hint_3")}</li>
          <li className={css.listItem}>{t("provably_fair.hint_4")}</li>
          <li className={css.listItem}>{t("provably_fair.hint_5")}</li>
          <li className={css.listItem}>{t("provably_fair.hint_6")}</li>
        </ol>
        <Image className={css.checkImage} src="checkIcon.png" variant="base" />
        <Typography className={css.title} color="header-small">
          {t("provably_fair.hints")}
        </Typography>
        <ul className={`${css.list} ${css.unorderedList}`}>
          <li className={css.listItem}>{t("provably_fair.hint_1")}</li>
          <li className={css.listItem}>{t("provably_fair.hint_2")}</li>
        </ul>
      </PageContainer>
    </Box>
  );
};
